import { styled } from 'stitches.config'
import { Stack } from 'components/Stack'

export const CreatePasswordRoot = styled('form', {
  minHeight: '100vh',
  backgroundColor: '$tertiary-200',
  padding: '$14 $3',

  '@bp1': {
    padding: '$10 $3',
  },

  '@bp2': {
    $$headerHeight: '80px',
    padding: '$10 144px',
    paddingTop: 'calc($$headerHeight + $10)',
  },

  '@bp3': {
    maxWidth: 'calc($max/2)',
    width: 'auto',
  },
})

export const TogglePasswordVisibilityButton = styled('button', {
  cursor: 'pointer',
  backgroundColor: 'transparent',
  border: 'none',
})
